import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip'
import useRightPanelToggle from './useRightPanelToggle'
import { PanelToggleButton } from './styled-components'

const RightPanelToggle = () => {
  const { expanded, onToggle, Icon, iconColor, label, tooltipOverrides } = useRightPanelToggle()

  return (
    <StatefulTooltip content={label} placement={PLACEMENT.left} popoverMargin={8} overrides={tooltipOverrides}>
      <PanelToggleButton type='button' data-panel-toggle aria-expanded={expanded} aria-label={label} onClick={onToggle}>
        <Icon size={20} color={iconColor} />
      </PanelToggleButton>
    </StatefulTooltip>
  )
}

export default RightPanelToggle
